module.exports = __webpack_public_path__ + "static/media/ConversationLogo.c938938c.svg";